// ** Third Party Components
import styled, { css } from "styled-components";

export const StyledSvgIconContainer = styled.span`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 18px;
	margin: 0 0.5rem 0 0;

	${({ $customMargin }) =>
		$customMargin &&
		css`
			margin: ${$customMargin};
		`}

	${({ $customWidth }) =>
		$customWidth &&
		css`
			width: ${$customWidth};
		`}

	svg {
		fill: ${({ theme: { colors } }) => colors.whiteAlways};
		display: block;
		height: 1em;

		${({ $customHeight }) =>
			$customHeight &&
			css`
				height: ${$customHeight};
			`};

		${({ $customVerticalAlign }) =>
			$customVerticalAlign &&
			css`
				vertical-align: ${$customVerticalAlign};
			`};
	}
`;
const HobbyIcon = ({
	customHeight,
	customMargin,
	customVerticalAlign,
	customWidth,
}) => {
	return (
		<StyledSvgIconContainer
			$customHeight={customHeight}
			$customMargin={customMargin}
			$customVerticalAlign={customVerticalAlign}
			$customWidth={customWidth}
		>
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
				{/*<!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--> https://fontawesome.com/icons/puzzle-piece?f=classic&s=solid  v5.15.4*/}
				<path
					d="M519.4 288.7c-41.5 0-59.5 31.6-82.1 31.6C377.4 320.2 432 144 432 144s-196.3 80-196.3-3.3c0-35.8 36.3-46.3 36.3-86C272 19.2 243.9 0 210.5 0c-34.7 0-66.4 18.9-66.4 56.3 0 41.4 31.7 59.3 31.7 81.8C175.9 207.7 0 166.8 0 166.8v333.2s178.6 41 178.6-28.7c0-22.5-40-40.1-40-81.5 0-37.5 29.3-56.3 63.6-56.3 33.7 0 61.8 19.2 61.8 54.7 0 39.7-36.3 50.2-36.3 86 0 60.8 129.7 25.7 181.2 25.7 0 0-34.7-120.1 25.8-120.1 36 0 46.4 36.2 86.3 36.2C556.7 416 576 388 576 354.4c0-34.2-19-65.8-56.6-65.8z"
					fill="#AC0DFC"
				/>
			</svg>
		</StyledSvgIconContainer>
	);
};

export default HobbyIcon;
